/**
 * Motion preference helpers.
 *
 * CSS `scroll-behavior: auto` (which `styles/motion.css` sets under
 * `prefers-reduced-motion: reduce`) only applies when a scroll is triggered
 * *without* an explicit `behavior`. An explicit `behavior: 'smooth'` argument to
 * `scrollIntoView()`/`scrollTo()` overrides the property, so JS-driven scrolling
 * animates anyway. Every such call site has to ask for the preference itself.
 */

/** True when the user asked the OS or the app to cut decorative motion. */
export function prefersReducedMotion() {
  if (typeof window === 'undefined') return false;
  if (document.documentElement?.dataset?.reduceMotion === 'true') return true;
  return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;
}

/**
 * The `behavior` to pass to a programmatic scroll.
 * @returns {'smooth'|'auto'}
 */
export function scrollBehavior() {
  return prefersReducedMotion() ? 'auto' : 'smooth';
}
